var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen"},[_vm._t("default"),_vm._v(" "),_c('LazyAppBackdropOverlay'),_vm._v(" "),_c('LazyAppModal'),_vm._v(" "),_c('LazyAppSidebar')],2)}
var staticRenderFns = []

export { render, staticRenderFns }